"use client";

import { c as _c } from "react/compiler-runtime";
import type { Genre, Premiere } from "@filmweb/sanity-types";
import Shows from "src/components/film/program/Shows";
import { useFilminfoSuspended } from "src/lib/client/useFilminfo";
import type { Show } from "src/lib/movieinfo/movieinfotypes";
import type { LocationParams } from "src/lib/program/LocationParams";
export type MovieSearchParams = {
  movieTitle: string;
  movieId?: never;
} | {
  movieId: string;
  movieTitle?: never;
};
export type ShowsVariables = LocationParams & MovieSearchParams & {
  date: string | null;
};

//#region [Props]
type ShowsForDateProps = {
  query: string;
  /** the query variables; date is yyyy-MM-dd, or null for all dates */
  variables: ShowsVariables;
  edi?: string | null;
  showCinemaFilter: boolean;
  movieTitle: string;
  premiere?: Premiere | null;
  genres?: Genre[];
  isKinoklubbMovie: boolean;
};
//#endregion

//#region [Component]
/** Suspends while the shows load - wrap it in QueryErrorBoundary and Suspense */
export default function ShowsForDate(t0) {
  const $ = _c(11);
  const {
    query,
    variables,
    edi,
    showCinemaFilter,
    movieTitle,
    premiere,
    genres,
    isKinoklubbMovie
  } = t0;
  const data = useFilminfoSuspended(query, variables);
  const shows = data.showQuery?.getShows as Show[];
  let t1;
  if ($[0] !== shows) {
    t1 = shows?.some(_temp) ?? false;
    $[0] = shows;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hasKinoklubbShows = t1;
  let t2;
  if ($[2] !== edi || $[3] !== genres || $[4] !== hasKinoklubbShows || $[5] !== isKinoklubbMovie || $[6] !== movieTitle || $[7] !== premiere || $[8] !== showCinemaFilter || $[9] !== shows) {
    t2 = <Shows edi={edi} applyCinemaFilter={showCinemaFilter} movieTitle={movieTitle} premiere={premiere} genres={genres} hasKinoklubbShows={hasKinoklubbShows} isKinoklubbMovie={isKinoklubbMovie} shows={shows} />;
    $[2] = edi;
    $[3] = genres;
    $[4] = hasKinoklubbShows;
    $[5] = isKinoklubbMovie;
    $[6] = movieTitle;
    $[7] = premiere;
    $[8] = showCinemaFilter;
    $[9] = shows;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}
//#endregion
function _temp(show) {
  return show?.isKinoklubb;
}